import { Operation } from '../types';

export type MakeDeleteOperation = (
  name: 'limitDelete' | 'constraintDelete' | 'earningMechanismDelete',
  id: string,
) => Operation<
  'limitDelete' | 'constraintDelete' | 'earningMechanismDelete',
  {
    id: string;
  }
>;

export const makeDeleteOperation: MakeDeleteOperation = (name, id) => ({
  name,
  variables: {
    id,
  },
});
